module.exports = __webpack_public_path__ + "img/wximg22.91577fa8.png";